import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../auth/AuthContext";
import { AlertCircle, ChevronRight, X } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

const PILLAR_COLORS = {
  financial: "#3e6b52",
  health: "#b94e4e",
  spirituality: "#7a5fb0",
  relationships: "#c18848",
  endgame: "#486a8f",
};

export default function NudgesBanner() {
  const [nudges, setNudges] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ascend_dismissed_nudges") || "[]");
    } catch {
      return [];
    }
  });
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/nudges`);
        setNudges(r.data.nudges || []);
      } catch (e) {}
    })();
  }, []);

  const dismiss = (key) => {
    const next = [...dismissed, key];
    setDismissed(next);
    localStorage.setItem("ascend_dismissed_nudges", JSON.stringify(next));
  };

  const visible = nudges.filter(
    (n) => !dismissed.includes(`${n.type}:${n.milestone_id || n.habit_id || n.title}`)
  );

  if (visible.length === 0) return null;

  return (
    <div className="mb-6 space-y-2">
      {visible.slice(0, 3).map((n, i) => {
        const key = `${n.type}:${n.milestone_id || n.habit_id || n.title}`;
        const pillarColor = PILLAR_COLORS[n.pillar] || "#486a8f";
        const isHigh = n.severity === "high";
        return (
          <div
            key={i}
            className={`flex items-center gap-3 rounded-xl border p-4 ${
              isHigh
                ? "bg-[#f5e6e6] border-[#e8c8c8]"
                : "bg-[#fbf5e8] border-[#ead7a8]"
            }`}
          >
            <div
              className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
              style={{ background: `${pillarColor}22` }}
            >
              <AlertCircle size={16} style={{ color: isHigh ? "#b94e4e" : pillarColor }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-body text-[13px] font-medium text-[#0f1724] truncate">
                {n.title}
              </p>
              <p className="font-body text-[12px] text-[#4b5563] truncate">{n.subtitle}</p>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/coach")}
              className="rounded-full text-[12px] text-[#486a8f] hover:bg-white/50 shrink-0"
            >
              Talk it out <ChevronRight size={12} className="ml-1" />
            </Button>
            <button
              onClick={() => dismiss(key)}
              className="text-[#9aa3ae] hover:text-[#0f1724] shrink-0"
              title="Dismiss"
            >
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
